module.exports = __webpack_public_path__ + "static/media/calm-serene.1aa70e43.png";